

    import {BaseMixins, Component,Prop} from '@/lib'
    @Component
    export default class TenantSwitch extends BaseMixins{
        @Prop({default:false}) value:boolean
        changedTenancyName:string='';

        cancel(){
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }else{
                this.changedTenancyName=window.basic.utils.getTenancyNameCookie();
            }
        }
        async changeTenant(){

            if (!this.changedTenancyName) {
                this.$util.basic.utils.setTenantIdCookie(undefined);
                this.$util.basic.utils.setTenancyNameCookie(undefined);
                this.$store.commit("app/setTenancyName", this.changedTenancyName);
                this.$emit('input',false);
            }else{
                let tenant=await this.$store.dispatch({
                    type:'system/account/isTenantAvailable',
                    data:{tenancyName:this.changedTenancyName}
                })
                switch(tenant.state){
                    case 1:
                        this.$util.basic.utils.setTenantIdCookie(tenant.tenantId);
                        this.$util.basic.utils.setTenancyNameCookie(this.changedTenancyName);
                        this.$store.commit("app/setTenancyName", this.changedTenancyName);
                        this.$emit('input',false);
                        return;
                    case 2:
                        this.$Modal.error({title:this.L('MessageTitle.SystemError'),content:this.L('Login.TenantIsNotActive')});
                        break;
                    case 3:
                        this.$Modal.error({title:this.L('MessageTitle.SystemError'),content:this.L('Login.ThereIsNoTenantDefinedWithName')});
                        break;
                }
            }
        }
    }
